import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";

// Pages
import LandingPage from "./pages/LandingPage";
import ReportFormPage from "./pages/ReportFormPage";
import RoutineRegistrationPage from "./pages/RoutineRegistrationPage";
import CompletionPage from "./pages/CompletionPage";
import SharedPlanPage from "./pages/SharedPlanPage";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminReportsListPage from "./pages/admin/AdminReportsListPage";
import AdminNewReportPage from "./pages/admin/AdminNewReportPage";
import AdminQuickPlanPage from "./pages/admin/AdminQuickPlanPage";
import AdminReportDetailPage from "./pages/admin/AdminReportDetailPage";
import AdminPlanGeneratorPage from "./pages/admin/AdminPlanGeneratorPage";
import AdminTrainingPage from "./pages/admin/AdminTrainingPage";
import AdminManualReportPage from "./pages/admin/AdminManualReportPage";
import AdminFormBuilderPage from "./pages/admin/AdminFormBuilderPage";
import AdminTemplatesPage from "./pages/admin/AdminTemplatesPage";
import AdminExportPage from "./pages/admin/AdminExportPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ErrorBoundary>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/report/:reportId" element={<ReportFormPage />} />
            <Route path="/report/:reportId/routine" element={<RoutineRegistrationPage />} />
            <Route path="/report/:reportId/complete" element={<CompletionPage />} />
            <Route path="/plan/:reportId" element={<SharedPlanPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/new" element={<AdminNewReportPage />} />
            <Route path="/admin/manual" element={<AdminManualReportPage />} />
            <Route path="/admin/quick-plan" element={<AdminQuickPlanPage />} />
            <Route path="/admin/reports" element={<AdminReportsListPage />} />
            <Route path="/admin/reports/:reportId" element={<AdminReportDetailPage />} />
            <Route path="/admin/reports/:reportId/plan" element={<AdminPlanGeneratorPage />} />
            <Route path="/admin/training" element={<AdminTrainingPage />} />
            <Route path="/admin/form-builder" element={<AdminFormBuilderPage />} />
            <Route path="/admin/templates" element={<AdminTemplatesPage />} />
            <Route path="/admin/export" element={<AdminExportPage />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
